import { render, staticRenderFns } from "./EditApirequestPage.vue?vue&type=template&id=0ec27567"
import script from "./EditApirequestPage.vue?vue&type=script&lang=js"
export * from "./EditApirequestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports